<div class="relative flex">
  <!-- Info Icon Button -->
  <button
    type="button"
    (click)="togglePopover()"
    class="inline-flex items-center justify-center w-6 h-6 text-gray-400 hover:text-gray-600 hover:cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded-full transition-colors duration-200"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
  >
    <svg
      class="w-6 h-6"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </button>

  <!-- Popover Content -->
  @if (isOpen()) {
  <div
    class="absolute z-50 w-80 bg-white rounded-lg shadow-xl border border-gray-200 transform"
    [ngClass]="getPopoverPositionClasses()"
    role="dialog"
    [attr.aria-labelledby]="headingId"
    [attr.aria-describedby]="descriptionId"
  >
    <!-- Popover Arrow -->
    <div
      class="absolute w-3 h-3 bg-white border transform rotate-45"
      [ngClass]="getArrowPositionClasses()"
    ></div>

    <!-- Popover Header -->
    <div class="px-4 py-3 border-b border-gray-100">
      <div class="flex items-center justify-between">
        <h3 [id]="headingId" class="text-sm font-semibold text-gray-900">
          {{ title() }}
        </h3>
        <button
          type="button"
          (click)="closePopover()"
          class="text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-sm transition-colors duration-200"
          aria-label="Close popover"
        >
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Popover Body -->
    <div class="p-4">
      <!-- Description (if provided) -->
      @if (description() !== '') {
      <p [id]="descriptionId" class="text-sm text-gray-600 mb-3">
        {{ description() }}
      </p>
      }

      <!-- Image Container -->
      @if (imageSrc() !== '') {
      <div class="relative">
        <img
          [src]="imageSrc()"
          [alt]="imageAlt()"
          class="w-full h-auto rounded-md border border-gray-200"
          [class.opacity-50]="imageLoading()"
          (load)="onImageLoad()"
          (error)="onImageError()"
        />

        <!-- Loading State -->
        @if (imageLoading()) {
        <div
          class="absolute inset-0 flex items-center justify-center bg-gray-50 rounded-md"
        >
          <svg
            class="animate-spin w-6 h-6 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        } @if (imageError()) {
        <!-- Error State -->
        <div
          class="absolute inset-0 flex flex-col items-center justify-center bg-gray-50 rounded-md text-gray-500"
        >
          <svg
            class="w-8 h-8 mb-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            ></path>
          </svg>
          <span class="text-sm">Failed to load image</span>
        </div>
        }
      </div>
      } @if (additionalContent()) {
      <!-- Additional Content (if provided) -->
      <div class="mt-3 text-sm text-gray-600">
        <ng-content></ng-content>
      </div>
      }
    </div>
  </div>

  }
</div>
